import React, { useEffect } from 'react';
import isNil from 'lodash/isNil';
import { PROTOCOL, APP_DOMAIN, ROOT_DOMAIN, SHARE } from 'constants';
import sessionStore from 'services/session_store';

const COOKIE_NAME = 'redirect_after_sign_in';

export const setRedirectAfterSignIn = (href) => {
  if (SHARE) {
    return;
  }
  if (!isNil(getRedirectAfterSignIn()) || href.endsWith(`${ROOT_DOMAIN}/`)) {
    return;
  }
  sessionStore.set(COOKIE_NAME, href);
};

export const getRedirectAfterSignIn = () => {
  return sessionStore.get(COOKIE_NAME);
};

export const deleteRedirectAfterSignIn = () => {
  return sessionStore.delete(COOKIE_NAME);
};

export const WithRedirectAfterSignIn = () => {
  const redirectTo = getRedirectAfterSignIn();

  useEffect(() => {
    if (!isNil(redirectTo) && redirectTo !== window.location.href) {
      deleteRedirectAfterSignIn();
      if (
        redirectTo.includes('/reset-password?') ||
        redirectTo.includes('?session_expired') ||
        redirectTo.includes('?integration_invitation_token') ||
        redirectTo === `${PROTOCOL}://${APP_DOMAIN}/`
      ) {
        return;
      }
      console.log('WithRedirectAfterSignIn');
      window.location.href = redirectTo;
    }
  }, []);
  return null;
};
